import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import { GlobalProvider } from './connections/GlobalContext';
import "./index.css";



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
   <HashRouter>
  <GlobalProvider>
      <App />
    </GlobalProvider>
</HashRouter>
);
reportWebVitals();
